module.exports = __webpack_public_path__ + "static/topo-69c73f24250f9da1fac62f1c56df9694.png";